export const getCurrencyIcon = () => {
    const country = 'United States'|| sessionStorage.getItem('country')
    const currencyMap = {
        "United States": "USD",
        "China": "CNY",
        "Russia": "RUB",
        "United Kingdom": "GBP",
        "Germany": "EUR",
        "Japan": "JPY",
        "India": "INR",
        "France": "EUR",
        "Australia": "AUD",
        "Thailand": "THB",
    };

    let currencyCode = currencyMap[country];

    if (!currencyCode) currencyCode= "USD"; // Handle unknown countries

    const formatter = new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currencyCode,
        currencyDisplay: "narrowSymbol", // Ensures correct format
    });

    return formatter.formatToParts(1).find((part) => part.type === "currency").value;
    const currentCountry = sessionStorage.getItem('country');
    if (currentCountry === "India")
        return '₹'
    return '฿'
}